<form name='' class="filter-list-form">
    <fieldset class="filter-group type-compact toggle-group">
        <div class="toggle-group__bar" (click)="expanded = !expanded" [ngClass]="{'is--active': expanded}">
            <legend class="filter-group__bar__title">{{aggregation.Meta.alias || aggregation.Meta.title}}:</legend>
            <button type="button" class="block-group-toggle-button type-small is--active" [ngClass]="{'is--active': expanded}">
                <span class="icon is--icon-plus">
                    <svg class="icon-svg">
                        <use xlink:href="/assets/gfx/svg-sprite.svg#icon-plus"></use>
                    </svg>
                </span>

                <span class="icon is--icon-min">
                    <svg class="icon-svg">
                        <use xlink:href="/assets/gfx/svg-sprite.svg#icon-min"></use>
                    </svg>
                </span>
            </button>
        </div>
        <ul class="filter-range filter-toggle-wrapper">
            <li class="filter-range-item">
                <label for="min" class="required">Start</label>
                <input type="number" name="min" placeholder="minValue" [(ngModel)]="minValue" (change)="valueChanged()" min="0" [max]="maxValue">

            </li>
            <li class="filter-range-item">
                <label for="max" class="required">End</label>
                <input type="number" name="max" placeholder="maxValue" [(ngModel)]="maxValue" (change)="valueChanged()" [min]="minValue" [max]="maxValue">
            </li>
        </ul>
    </fieldset>
</form>
